function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/* globals XMLHttpRequest, FormData */
/**
 * @module adapter-ckfinder/uploadadapter
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FileRepository from '@ckeditor/ckeditor5-upload/src/filerepository';
import { getCsrfToken } from './utils';
/**
 * A plugin that enables file uploads in CKEditor 5 using the CKFinder server–side connector.
 *
 * See the {@glink features/image-upload/ckfinder "CKFinder file manager integration" guide} to learn how to configure
 * and use this feature as well as find out more about the full integration with the file manager
 * provided by the {@link module:ckfinder/ckfinder~CKFinder} plugin.
 *
 * Check out the {@glink features/image-upload/image-upload comprehensive "Image upload overview"} to learn about
 * other ways to upload images into CKEditor 5.
 *
 * @extends module:core/plugin~Plugin
 */
var CKFinderUploadAdapter = /*#__PURE__*/
function (_Plugin) {
    _inherits(CKFinderUploadAdapter, _Plugin);
    var _super = _createSuper(CKFinderUploadAdapter);
    function CKFinderUploadAdapter() {
        _classCallCheck(this, CKFinderUploadAdapter);
        return _super.apply(this, arguments);
    }
    _createClass(CKFinderUploadAdapter, [{
            key: 'init',
            value: /**
     * @inheritDoc
     */
            function init() {
                var _this = this;
                var url = this.editor.config.get('ckfinder.uploadUrl');
                if (!url) {
                    return;
                }
                // Register CKFinderAdapter
                this.editor.plugins.get(FileRepository).createUploadAdapter = function (loader) {
                    return new UploadAdapter(loader, url, _this.editor.t);
                };
            }
        }], [
        {
            key: 'requires',
            get: /**
     * @inheritDoc
     */
            function get() {
                return [FileRepository];
            }    /**
     * @inheritDoc
     */
        },
        {
            key: 'pluginName',
            get: function get() {
                return 'CKFinderUploadAdapter';
            }
        }
    ]);
    return CKFinderUploadAdapter;
}(Plugin);
/**
 * Upload adapter for CKFinder.
 *
 * @private
 * @implements module:upload/filerepository~UploadAdapter
 */
export {
    CKFinderUploadAdapter as default
};
var UploadAdapter = /*#__PURE__*/
function () {
    /**
   * Creates a new adapter instance.
   *
   * @param {module:upload/filerepository~FileLoader} loader
   * @param {String} url
   * @param {module:utils/locale~Locale#t} t
   */
    function UploadAdapter(loader, url, t) {
        _classCallCheck(this, UploadAdapter);
        /**
     * FileLoader instance to use during the upload.
     *
     * @member {module:upload/filerepository~FileLoader} #loader
     */
        this.loader = loader;
        /**
     * Upload URL.
     *
     * @member {String} #url
     */
        this.url = url;
        /**
     * Locale translation method.
     *
     * @member {module:utils/locale~Locale#t} #t
     */
        this.t = t;
    }
    /**
   * Starts the upload process.
   *
   * @see module:upload/filerepository~UploadAdapter#upload
   * @returns {Promise.<Object>}
   */
    _createClass(UploadAdapter, [
        {
            key: 'upload',
            value: function upload() {
                var _this2 = this;
                return this.loader.file.then(function (file) {
                    return new Promise(function (resolve, reject) {
                        _this2._initRequest();
                        _this2._initListeners(resolve, reject, file);
                        _this2._sendRequest(file);
                    });
                });
            }    /**
     * Aborts the upload process.
     *
     * @see module:upload/filerepository~UploadAdapter#abort
     */
        },
        {
            key: 'abort',
            value: function abort() {
                if (this.xhr) {
                    this.xhr.abort();
                }
            }    /**
     * Initializes the XMLHttpRequest object.
     *
     * @private
     */
        },
        {
            key: '_initRequest',
            value: function _initRequest() {
                var xhr = this.xhr = new XMLHttpRequest();
                xhr.open('POST', this.url, true);
                xhr.responseType = 'json';
            }    /**
     * Initializes XMLHttpRequest listeners.
     *
     * @private
     * @param {Function} resolve Callback function to be called when the request is successful.
     * @param {Function} reject Callback function to be called when the request cannot be completed.
     * @param {File} file File instance to be uploaded.
     */
        },
        {
            key: '_initListeners',
            value: function _initListeners(resolve, reject, file) {
                var xhr = this.xhr;
                var loader = this.loader;
                var t = this.t;
                var genericError = t('Cannot upload file:') + ' '.concat(file.name, '.');
                xhr.addEventListener('error', function () {
                    return reject(genericError);
                });
                xhr.addEventListener('abort', function () {
                    return reject();
                });
                xhr.addEventListener('load', function () {
                    var response = xhr.response;
                    if (!response || !response.uploaded) {
                        return reject(response && response.error && response.error.message ? response.error.message : genericError);
                    }
                    resolve({ 'default': response.url });
                });
                // Upload progress when it's supported.
                /* istanbul ignore else */
                if (xhr.upload) {
                    xhr.upload.addEventListener('progress', function (evt) {
                        if (evt.lengthComputable) {
                            loader.uploadTotal = evt.total;
                            loader.uploaded = evt.loaded;
                        }
                    });
                }
            }    /**
     * Prepares the data and sends the request.
     *
     * @private
     * @param {File} file File instance to be uploaded.
     */
        },
        {
            key: '_sendRequest',
            value: function _sendRequest(file) {
                // Prepare form data.
                var data = new FormData();
                data.append('upload', file);
                data.append('ckCsrfToken', getCsrfToken());
                // Send request.
                this.xhr.send(data);
            }
        }
    ]);
    return UploadAdapter;
}();